import store from '../index'
import router from '../../router/index'
import {
  Axios,
  AsyncAxios
} from '@/common/request'
export default {
  state: {
    info: '', // 每次刷新都要通过token请求个人信息来筛选动态路由
    AdmNo: {},
    questionInfo: {},
    //临时配置,企业或公司展示字段判断
    companyList: [{
      name: '四川渡众教育科技有限公司',
      id: '2036',
    }], // 企业公司/临时修改展示字段
  },
  mutations: {
    getInfo(state, info) {
      state.info = info
      if (info.token != null) {
        store.dispatch('setToken', info.token)
        sessionStorage.setItem('info', JSON.stringify(store.getters.info))
      }
    },
    setRole(state, options) { // 切换角色，测试权限管理
      state.info = {
        UserID: options.UserID,
        LoginName: options.LoginName,
        UserName: options.UserName,
        RoleName: options.RoleName,
        RoleID: options.RoleID,
        Menus: options.Menus,
        DepartmentID: options.DepartmentID,
        DepartmentName: options.DepartmentName,
        Avatar: options.Avatar,
        HospitalID: options.HospitalID,
        HospitalName: options.HospitalName,
        Hospitals: options.Hospitals
      }
      sessionStorage.setItem('info', JSON.stringify(store.getters.info));
      store.dispatch('newRoutes', {
        menus: options.Menus,
        role: options.RoleName
      })
      router.addRoutes(store.getters.addRouters)
    },
    SetAdmNo(state, AdmNo) {
      state.AdmNo = AdmNo
      sessionStorage.setItem('AdmNo', AdmNo)
    },
    SetQuestionInfo(state, info) {
      state.questionInfo = info

      sessionStorage.setItem('questionInfo', info)
    }
  },
  actions: {
    async getInfo({
      commit
    }, token) {
      await AsyncAxios('Login/RequestInfoByToken', 'get', {
        accessToken: token
      }, this).then(ret => {
        if (!ret.Data.UserID) {
          store.dispatch('setToken', "")
          return;
        }
        var info = {
          UserID: ret.Data.UserID,
          LoginName: ret.Data.LoginName,
          UserName: ret.Data.UserName,
          RoleName: ret.Data.RoleName,
          RoleID: ret.Data.RoleID,
          Menus: ret.Data.Menus,
          DepartmentID: ret.Data.DepartmentID,
          DepartmentName: ret.Data.DepartmentName,
          Avatar: ret.Data.Avatar,
          HospitalID: ret.Data.HospitalID,
          HospitalName: ret.Data.HospitalName,
          Hospitals: ret.Data.Hospitals,
          token: ret.Data.Token
        }
        window.sessionStorage.setItem('token', ret.Data.Token)
        commit('getInfo', info)
      }).catch(() => {
        if (window.sessionStorage.getItem('token') != null) {
          // this.getInfo(token);
        }
        store.dispatch('setToken', "");
      });
    },
    setRole({
      commit
    }, options) {
      // 权限测试
      commit('setRole', options)
    },
    SetAdmNo({
      commit
    }, AdmNo) {
      // 权限测试
      commit('SetAdmNo', AdmNo)
    },
    SetQuestionInfo({
      commit
    }, info) {
      // 权限测试
      commit('SetQuestionInfo', info)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/role.js